import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoadingSpinner from 'components/loading_spinner';
import ImportSummary from './import_summary';
import { getCurrentFile } from '../store/selectors';
import { isLoadingRecords } from '../store/run_records_selectors';
import ImportActions from './import_actions';
import { retrieveImportSummary } from '../store/actions/run_records';

import './review.scss';

export function Review({
  currentFile,
  loadingRecords,
  retrieveImportSummary
}) {

  const renderReviewRecords = () => {
    if (loadingRecords) {
      return <LoadingSpinner />;
    } else {
      return <ImportSummary />;
    }
  };

  useEffect(() => {
    retrieveImportSummary();
  }, [currentFile]);

  return (
    <div className="review">
      <div className="mb-4 review-title">
        <h3 className="semi-bold mb-4">Review Import</h3>
        <div className="pull-right">
          <ImportActions />
        </div>
      </div>
      {renderReviewRecords()}
    </div>
  );
}

Review.propTypes = {
  currentFile: PropTypes.object.isRequired,
  loadingRecords: PropTypes.bool.isRequired,
  retrieveImportSummary: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
  loadingRecords: isLoadingRecords(state)
});

const mapDispatchToProps = {
  retrieveImportSummary
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);
